
export default [
	{
		path: '/admin/draw-settings',
		name: 'draw-setting',
		meta: { requiresAuth: true },
		component: () => import('@/pages/administrator/draw-setting')
	}
]